import { observable, action, runInAction } from 'mobx';

export class TriggerStore {
    constructor(botStore) {
        this.botStore = botStore;
    }

    @observable logs = [];
    @observable status = {};

    @action addTrigger(trigger) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];
        if (trigger.type === 'strategy') {
            trigger.buy_actions = [];
            trigger.sell_actions = [];
        } else {
            trigger.default_actions = [];
        }

        if (trigger.type === 'time_range') {
            trigger.start_hours = trigger.start_time.hours();
            trigger.start_minutes = trigger.start_time.minutes();
            trigger.end_hours = trigger.end_time.hours();
            trigger.end_minutes = trigger.end_time.minutes();

            trigger.start_time = trigger.start_time.format('HH:mm');
            trigger.end_time = trigger.end_time.format('HH:mm');
        }

        currentTriggers.push(trigger);
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    @action updateTrigger(id, trigger) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];
        let next = { ...currentTriggers[id], ...trigger };

        if (next.type === 'time_range') {
            next.start_hours = next.start_time.hours();
            next.start_minutes = next.start_time.minutes();
            next.end_hours = next.end_time.hours();
            next.end_minutes = next.end_time.minutes();

            next.start_time = next.start_time.format('HH:mm');
            next.end_time = next.end_time.format('HH:mm');
        }

        currentTriggers[id] = next;
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    @action updateAction(mode, triggerId, actionId, key, value) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];
        currentTriggers[triggerId][`${mode}_actions`][actionId][key] = value;
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    @action removeTrigger(id) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];
        currentTriggers.splice(id, 1);
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    @action addAction(mode, id, action) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];

        let actionRec = {
            id: action.action_id,
            name: action.name
        };

        action.inputs.forEach(a => {
            actionRec[a.name] = a.default;
        });
        console.log(mode);
        currentTriggers[id][`${mode}_actions`].push(actionRec);
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    @action addDefaultAction(id, action) {
        let currentTrigger = {
            ...(this.botStore.currentConfiguration.default_trigger || { actions: [] })
        };

        let actionRec = {
            id: action.action_id,
            name: action.name
        };

        action.inputs.forEach(a => {
            actionRec[a.name] = a.default;
        });

        currentTrigger.actions.push(actionRec);
        this.botStore.updateConfigValue('default_trigger', currentTrigger);
    }

    @action removeDefaultAction(actionId) {
        let currentTrigger = {
            ...(this.botStore.currentConfiguration.default_trigger || { actions: [] })
        };
        currentTrigger.actions.splice(actionId, 1);
        this.botStore.updateConfigValue('default_trigger', currentTrigger);
    }

    @action updateDefaultAction(actionId, key, value) {
        let currentTrigger = {
            ...(this.botStore.currentConfiguration.default_trigger || { actions: [] })
        };
        currentTrigger.actions[actionId][key] = value;
        this.botStore.updateConfigValue('default_trigger', currentTrigger);
    }

    @action updateDefaultValue(key, value) {
        let currentTrigger = {
            ...(this.botStore.currentConfiguration.default_trigger || { actions: [] })
        };
        currentTrigger[key] = value;
        this.botStore.updateConfigValue('default_trigger', currentTrigger);
    }

    @action removeAction(mode, triggerId, actionId) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];
        currentTriggers[triggerId][`${mode}_actions`].splice(actionId, 1);
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    @action triggerUp(id) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];
        this.move(currentTriggers, id, -1);
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    @action triggerDown(id) {
        let currentTriggers = [...(this.botStore.currentConfiguration.triggers || [])];
        this.move(currentTriggers, id, 1);
        this.botStore.updateConfigValue('triggers', currentTriggers);
    }

    move(array, index, delta) {
        let newIndex = index + delta;
        if (newIndex < 0 || newIndex === array.length) return; //Already at the top or bottom.
        let indexes = [index, newIndex].sort(); //Sort the indixes
        array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]); //Replace from lowest index, two elements, reverting the order
    }

    @action getLogs() {
        if (!this.watcher) {
            this.watcher = this.query(logs => {
                this.setLogs(logs);
            });
        }

        this.botStore.socket.on('triggers:update', ({ data }) => {
            runInAction(() => {
                this.status = data;
            });
        });
    }

    @action setLogs(logs) {
        this.logs = logs;
    }

    @action close() {
        this.logs = [];
        this.watcher && this.watcher();
        this.watcher = null;
    }

    query = cb => {
        const currentUser = this.botStore.rootStore.fbAuth.currentUser;

        return this.botStore.rootStore.db
            .collection(`users/${currentUser.uid}/botConfigs/`)
            .doc(this.botStore.currentBot)
            .collection('trigger_logs')
            .orderBy('date', 'desc')
            .limit(20)
            .onSnapshot(function(snapshot) {
                let recordSet = [];
                snapshot.forEach(recordSnapshot => {
                    recordSet.push({ id: recordSnapshot.id, ...recordSnapshot.data() });
                });
                cb(recordSet);
            });
    };
}



// WEBPACK FOOTER //
// ./src/stores/TriggerStore.js